import React, { Component } from "react";
import styles from "./CategoriesSettings.local.scss";
import classnames from "classnames";
import { ICONS, SvgIcon } from "../Common/Icons";
import LabelsForm from "./LabelsForm";
import _ from "i18n";

class ItemCategory extends Component {
  renderCreatedState = (
    item,
    lng,
    superCategoriesOptions,
    analysisPlanOptions,
    valuationOptions,
    active = false,
    labelsForm,
    associatedSuperCategory,
    associatedAnalysisPlan,
    associatedValuation,
    labelsNeedsUpdate,
    associated,
    isClassification,
    isBillable
  ) => {
    return (
      <div
        className={`${
          associated === true
            ? classnames(
                styles.item_category,
                styles.created_state,
                active ? active : ""
              )
            : classnames(
                styles.item_category,
                styles.item_category1,
                styles.created_state,
                active ? active : ""
              )
        }`}
        style={{ border: active ? "1px solid #18a0fb" : "" }}
      >
        <span
          className={`${
            associated === true
              ? classnames(styles.item_label, styles.item_label_categ)
              : classnames(styles.item_label)
          }`}
        >
          {item.label[lng]}
          <span>
            {item.isBillable && (
              <img
                src={"img/icons/bill.svg"}
                width={"5%"}
                style={{ marginLeft: "6%", marginTop: "-2%" }}
                alt={""}
              />
            )}
          </span>
        </span>
        {associated ? (
          <div className={styles.items}>
            <div className={styles.associatedAccount} style={{ width: "70%" }}>
              {this.props.associatedSuperCategory.length > 0 && (
                <span className={styles.account_label}>
                  {_("AssociatedWith")} : <br />
                  <span>
                    {associatedSuperCategory[0].label.length <= 28
                      ? associatedSuperCategory[0].label
                      : associatedSuperCategory[0].label.slice(0, 28) + "..."}
                  </span>
                </span>
              )}
            </div>
            <div className={styles.associatedAccount} style={{ width: "70%" }}>
              {this.props.associatedAnalysisPlan.length > 0 && (
                <span className={styles.account_label}>
                  {_("BelongsTo")} : <br />
                  <span>
                    {associatedAnalysisPlan[0].label.length <= 28
                      ? associatedAnalysisPlan[0].label
                      : associatedAnalysisPlan[0].label.slice(0, 28) + "..."}
                  </span>
                </span>
              )}
            </div>
            <div className={styles.associatedAccount} style={{ width: "70%" }}>
              {this.props.associatedValuation.length > 0 && (
                <span className={styles.account_label}>
                  {_("classified")} : <br />
                  <span>
                    {associatedValuation[0].label.length <= 28
                      ? associatedValuation[0].label
                      : associatedValuation[0].label.slice(0, 28) + "..."}
                  </span>
                </span>
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        {active && labelsNeedsUpdate > 0
          ? this.renderValidateUpdatesActions()
          : this.renderDefaultActions(item)}

        {active && (
          <LabelsForm
            billable={item.isBillable}
            isBillable={isBillable}
            labels={labelsForm}
            superCategoriesOptions={superCategoriesOptions}
            analysisPlanOptions={analysisPlanOptions}
            valuationOptions={valuationOptions}
            item={item}
            associated={associated}
            isClassification={isClassification}
            selectedSuperCategory={this.props.selectedSuperCategory}
            onChangeSelectedSuperCategory={
              this.props.onChangeSelectedSuperCategory
            }
            selectedAnalysisPlan={this.props.selectedAnalysisPlan}
            onChangeSelectedAnalysisPlan={
              this.props.onChangeSelectedAnalysisPlan
            }
            selectedValuation={this.props.selectedValuation}
            onChangeSelectedValuation={this.props.onChangeSelectedValuation}
            onChangeLabelFormFr={this.props.onChangeLabelFormFr}
            onChangeLabelFormEn={this.props.onChangeLabelFormEn}
            onChangeLabelFormNl={this.props.onChangeLabelFormNl}
            onChangeLabelFormCoefficient={
              this.props.onChangeLabelFormCoefficient
            }
            handleUpdateBillableState={this.props.handleUpdateBillableState}
          />
        )}
      </div>
    );
  };

  renderValidateUpdatesActions = () => {
    return (
      <div
        className={styles.actions}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        {this.props.active && this.props.saving ? (
          <div>
            <span className={styles.action} />
            <span className={styles.action}>
              <img
                src={"/img/icons/tail-spin-green.svg"}
                alt={""}
                className={styles.loading}
              />
            </span>
          </div>
        ) : (
          <div>
            <span
              className={styles.action}
              onClick={() => this.props.resetLabels()}
            >
              <img
                src={"/img/icons/back_arrow.svg"}
                className={styles.back_arrow}
                alt={""}
              />
            </span>
            <span
              className={styles.action}
              onClick={() => this.props.handleUpdateCategory()}
            >
              <img
                src={"/img/icons/check-mark.svg"}
                className={styles.check_mark}
                alt={""}
              />
            </span>
          </div>
        )}
      </div>
    );
  };

  renderDefaultActions = item => {
    return (
      <div
        className={styles.actions}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <div>
          <span
            className={styles.action}
            onClick={() => this.props.handleDisplayDeleteCategory(item.id)}
          >
            <SvgIcon icon={ICONS.Garbage} className={styles.delete} />
          </span>
          <span
            className={styles.action}
            onClick={() =>
              this.props.handleToggleActivatedCategoryToUpdate(
                item.id,
                item.label,
                item.superCategory,
                item.analysisPlan,
                item.valuations,
                item.isBillable
              )
            }
          >
            <i className={"icon icon-arrow-down"} />
          </span>
        </div>
      </div>
    );
  };

  render() {
    let {
      item,
      lng,
      superCategoriesOptions,
      analysisPlanOptions,
      valuationOptions,
      active,
      labelsForm,
      associatedSuperCategory,
      associatedAnalysisPlan,
      associatedValuation,
      labelsNeedsUpdate,
      associated,
      isClassification,
      isBillable
    } = this.props;

    return this.renderCreatedState(
      item,
      lng,
      superCategoriesOptions,
      analysisPlanOptions,
      valuationOptions,
      active,
      labelsForm,
      associatedSuperCategory,
      associatedAnalysisPlan,
      associatedValuation,
      labelsNeedsUpdate,
      associated,
      isClassification,
      isBillable
    );
  }
}

export default ItemCategory;



// WEBPACK FOOTER //
// ./src/components/CategorySettings/ItemCategory.js